import { observer } from 'mobx-react-lite'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { useInjection } from '@core/providers/inversify-react.provider'
import { NavigationComponent } from '@core/infra/navigation/navigation.component'
import { BreadcrumbsComponent } from '@core/infra/breadcrumbs/breadcrumbs.component'
import { ShellPresenter } from '../shell.presenter'

export const SidebarComponent = observer(() => {
  const shellPresenter: ShellPresenter = useInjection(ShellPresenter)
  const vm = shellPresenter.viewModel

  if (!vm.showSidebar) {
    return null
  }

  return (
    <>
      {/* Below md the sidebar is a fixed overlay (see below), so it needs a
          backdrop to close on outside-tap; md:hidden removes it entirely once
          the sidebar rejoins normal flow and pushes content instead. Below the
          top bar's z-50 so the toggle stays reachable while this is open. */}
      <div
        className="fixed inset-0 z-30 bg-black/30 md:hidden"
        onClick={() => shellPresenter.toggleSidebar()}
        aria-hidden="true"
      />
      {/* fixed+w-72 below md (overlay, floats above content); md:static hands
          position back to the flex row so it pushes content like before, and
          md:w-auto goes back to sizing off the nav content instead of a fixed width.
          No overflow here — breadcrumbs (shrink-0 below) must stay visible always;
          scrolling belongs to NavigationComponent's own nav lists only. */}
      <div className="fixed inset-y-0 left-0 z-50 flex w-72 max-w-[85vw] shrink-0 flex-col border-r border-shell-border bg-shell-surface min-h-0 md:static md:z-auto md:w-auto md:max-w-none">
        {/* A mobile overlay panel needs its own close affordance — the top
            bar's toggle can be out of thumb's reach once this covers it. */}
        <div className="flex shrink-0 justify-end px-4 py-3 md:hidden">
          <button
            type="button"
            onClick={() => shellPresenter.toggleSidebar()}
            className="-m-2.5 flex items-center justify-center rounded-md p-2.5 text-shell-ink-secondary hover:text-shell-ink"
            aria-label={vm.toggleSidebarLabel}
            title={vm.toggleSidebarLabel}
          >
            <XMarkIcon aria-hidden="true" className="size-6" />
          </button>
        </div>
        {/* Describes where you are in the nav below it, so it lives with the
            nav. w-full, not a fixed width: the panel is md:w-auto and grows as
            columnView columns open, and a fixed width leaves the divider short
            of them. */}
        <div className="w-full shrink-0 border-b border-shell-border px-4 py-3">
          <BreadcrumbsComponent />
        </div>
        <NavigationComponent />
      </div>
    </>
  )
})
